import LangEnum from '../../../../lang/LangEnum';
import { LangEnumOption } from '../../../business-policies/business-policy.options';

enum OrderSignatureFilterOptions {
  COMPLETE_CONTRACT = 'COMPLETE_CONTRACT',
  SIGNED_BY_BRAND = 'SIGNED_BY_BRAND',
  SIGNED_BY_STORE = 'SIGNED_BY_STORE',
  PENDING_STORE = 'PENDING_STORE',
  NO_CONTRACT = 'NO_CONTRACT',
  NO_SIGNATURES = 'NO_SIGNATURES',
}

export const orderSignatureLangEnumOptions: Array<LangEnumOption> = [
  {
    label: LangEnum.GLOBAL_COMPLETE_CONTRACT,
    value: OrderSignatureFilterOptions.COMPLETE_CONTRACT,
  },
  {
    label: LangEnum.GLOBAL_SIGNED_BY_BRAND,
    value: OrderSignatureFilterOptions.SIGNED_BY_BRAND,
  },
  {
    label: LangEnum.GLOBAL_SIGNED_BY_STORE,
    value: OrderSignatureFilterOptions.SIGNED_BY_STORE,
  },
  {
    label: LangEnum.GLOBAL_PENDING_STORE,
    value: OrderSignatureFilterOptions.PENDING_STORE,
  },
  {
    label: LangEnum.GLOBAL_NO_CONTRACT,
    value: OrderSignatureFilterOptions.NO_CONTRACT,
  },
  {
    label: LangEnum.GLOBAL_NO_SIGNATURES,
    value: OrderSignatureFilterOptions.NO_SIGNATURES,
  },
];
